import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// Layouts
import AdminLayout from "../modules/admin/layout/AdminLayout";
import DoctorLayout from "../modules/doctor/layout/DoctorLayout";
import PatientLayout from "../modules/patient/layout/PatientLayout";
import LabLayout from "../modules/lab/layout/LabLayout";
import WebsiteLayout from "../modules/website/layout/WebsiteLayout";

// Auth Pages
//import Login from "../modules/auth/Login";
import PLogin from "../modules/auth/PLogin";
import DocLabLogin from "../modules/auth/DocLabLogin";
import AdminLogin from "../modules/auth/AdminLogin";
import PRegister from "../modules/auth/PRegister";
import DLRegister from "../modules/auth/DLRegister";

// Admin Pages
import AdminDashboard from "../modules/admin/pages/Dashboard";
import DoctorList from "../modules/admin/pages/DoctorList";
import LabList from "../modules/admin/pages/LabList";
import PatientList from "../modules/admin/pages/PatientList";
import AdminReports from "../modules/admin/pages/Reports";
import BroadcastMessage from "../modules/admin/pages/BroadcastMessage";
import PaymentManagement from "../modules/admin/pages/PaymentManagement";
import TestCategories from "../modules/admin/pages/TestCategories";
import Advertisements from "../modules/admin/pages/Advertisements";
import Clinics from "../modules/admin/pages/Clinics";

// Website Pages
import Home from "../modules/website/pages/Home";
import Policies from "../modules/website/pages/Policies";
import FAQ from "../modules/website/pages/FAQ";
import ContactUs from "../modules/website/pages/ContactUs";

// Patient Pages
import PatientDashboard from "../modules/patient/pages/Dashboard";
import PatientProfile from "../modules/patient/pages/Profile";
import SearchDoctors from "../modules/patient/pages/SearchDoctors";
import BookAppointment from "../modules/patient/pages/BookAppointment";
import SearchDiagnostics from "../modules/patient/pages/SearchDiagnostics";
import BookDiagnostic from "../modules/patient/pages/BookDiagnostic";
import PatientBookingHistory from "../modules/patient/pages/BookingHistory";
import PatientPaymentHistory from "../modules/patient/pages/PaymentHistory";
import PatientIssues from "../modules/patient/pages/Issues";

// Doctor Pages
import DoctorDashboard from "../modules/doctor/pages/Dashboard";
import DoctorProfile from "../modules/doctor/pages/Profile";
import ScheduleManagement from "../modules/doctor/pages/ScheduleManagement";
import ChamberManagement from "../modules/doctor/pages/ChamberManagement";
import AppointmentList from "../modules/doctor/pages/AppointmentList";
import DoctorAppointmentHistory from "../modules/doctor/pages/AppointmentHistory";

// Lab Pages
import LabDashboard from "../modules/lab/pages/Dashboard";
import LabProfile from "../modules/lab/pages/Profile";
import TestCatalogue from "../modules/lab/pages/TestCatalogue";
import LabBookings from "../modules/lab/pages/Bookings";
import LabSchedule from "../modules/lab/pages/Schedule";

// Payment
import PaymentCheckout from "../modules/payment/PaymentCheckout";
import PaymentSuccess from "../modules/payment/PaymentSuccess";
import PaymentFailed from "../modules/payment/PaymentFailed";

// Guards
import ProtectedRoute from "./ProtectedRoute";
import { ROLES } from "../context/AuthContext";

export default function AppRouter() {
  return (
    <Routes>
      {/* Public Auth Routes */}
     <Route path="/login/patient" element={<PLogin />} />
<Route path="/login/doctor-lab" element={<DocLabLogin />} />
<Route path="/login/sai7tot7san5" element={<AdminLogin />} />

      <Route path="/register/patient" element={<PRegister />} />
<Route path="/register/doc-lab" element={<DLRegister />} />

      {/* Website / Public Routes */}
      <Route path="/" element={<WebsiteLayout />}>
        <Route index element={<Home />} />
        <Route path="policies" element={<Policies />} />
        <Route path="faq" element={<FAQ />} />
        <Route path="contact" element={<ContactUs />} />
      </Route>

      {/* Admin Routes */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute role={ROLES.ADMIN}>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="doctors" element={<DoctorList />} />
        <Route path="labs" element={<LabList />} />
        <Route path="patients" element={<PatientList />} />
        <Route path="reports" element={<AdminReports />} />
        <Route path="broadcast" element={<BroadcastMessage />} />
        <Route path="payments" element={<PaymentManagement />} />
        <Route path="test-categories" element={<TestCategories />} />
        <Route path="advertisements" element={<Advertisements />} />
        <Route path="clinics" element={<Clinics />} />
      </Route>

      {/* Patient Routes */}
      <Route
        path="/patient"
        element={
          <ProtectedRoute role={ROLES.PATIENT}>
            <PatientLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<PatientDashboard />} />
        <Route path="profile" element={<PatientProfile />} />
        <Route path="search-doctors" element={<SearchDoctors />} />
        <Route path="book-appointment/:doctorId" element={<BookAppointment />} />
        <Route path="search-diagnostics" element={<SearchDiagnostics />} />
        <Route path="book-diagnostic/:labId" element={<BookDiagnostic />} />
        <Route path="booking-history" element={<PatientBookingHistory />} />
        <Route path="payment-history" element={<PatientPaymentHistory />} />
        <Route path="issues" element={<PatientIssues />} />
      </Route>

      {/* Doctor Routes */}
      <Route
        path="/doctor"
        element={
          <ProtectedRoute role={ROLES.DOCTOR}>
            <DoctorLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DoctorDashboard />} />
        <Route path="profile" element={<DoctorProfile />} />
        <Route path="schedule" element={<ScheduleManagement />} />
        <Route path="chambers" element={<ChamberManagement />} />
        <Route path="appointments" element={<AppointmentList />} />
        <Route path="history" element={<DoctorAppointmentHistory />} />
      </Route>

      {/* Lab Routes */}
      <Route
        path="/lab"
        element={
          <ProtectedRoute role={ROLES.LAB}>
            <LabLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<LabDashboard />} />
        <Route path="profile" element={<LabProfile />} />
        <Route path="test-catalogue" element={<TestCatalogue />} />
        <Route path="bookings" element={<LabBookings />} />
        <Route path="schedule" element={<LabSchedule />} />
      </Route>

      {/* Payment Routes */}
      <Route path="/payment/checkout" element={<PaymentCheckout />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/failed" element={<PaymentFailed />} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
